module.exports = __webpack_public_path__ + "static/media/country_cf.681ce0b4.webp";